import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { userManagementBaseUrl } from "../../redux-toolkit/endpoints";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";

// ── BRSR Services ──────────────────────────────────────
import {
    useSaveSpeciesRegistryMutation,
    useUpdateSpeciesRegistryMutation,
    useGetSpeciesRegistryByIdMutation,
    useBulkUploadSpeciesRegistryMutation,
} from "../../redux-toolkit/services/speciesRegistryService";
import {
    useSaveMethodLibraryMutation,
    useUpdateMethodLibraryMutation,
    useGetMethodLibraryByIdMutation,
    useBulkUploadMethodLibraryMutation,
} from "../../redux-toolkit/services/methodLibraryService";
import {
    useSaveRiskMaterialityLogMutation,
    useUpdateRiskMaterialityLogMutation,
    useGetRiskMaterialityLogByIdMutation,
    useBulkUploadRiskMaterialityLogMutation,
} from "../../redux-toolkit/services/riskMaterialityLogService";
import {
    useSaveEmissionsLedgerMutation,
    useUpdateEmissionsLedgerMutation,
    useGetEmissionsLedgerByIdMutation,
    useBulkUploadEmissionsLedgerMutation,
} from "../../redux-toolkit/services/emissionsLedgerService";
import {
    useSaveAuditDisclosureSnapshotMutation,
    useUpdateAuditDisclosureSnapshotMutation,
    useGetAuditDisclosureSnapshotByIdMutation,
    useBulkUploadAuditDisclosureSnapshotMutation,
} from "../../redux-toolkit/services/auditDisclosureSnapshotService";
import {
    useSaveCarbonProjectMutation,
    useUpdateCarbonProjectMutation,
    useGetCarbonProjectByIdMutation,
    useBulkUploadCarbonProjectMutation,
    useFindAllCarbonProjectMutation,
    useGetAllCarbonProjectsQuery,
} from "../../redux-toolkit/services/carbonProjectService";
import {
    useSaveEmissionFactorMutation,
    useUpdateEmissionFactorMutation,
    useGetEmissionFactorByIdMutation,
    useBulkUploadEmissionFactorMutation,
} from "../../redux-toolkit/services/emissionFactorService";
import { useFindAllSpeciesRegistryMutation } from "../../redux-toolkit/services/speciesRegistryService";

// ── Lookup Services ──────────────────────────────────────
import { useFindAllEntityMasterMutation } from "../../redux-toolkit/services/entityMasterService";
import { useFindAllAssetsMutation } from "../../redux-toolkit/services/assetsService";
import { useFindAllMethodLibraryMutation } from "../../redux-toolkit/services/methodLibraryService";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};

const BSRLComplianceData = (props: Props) => {
    const localUserObj: any = getLocalStorageData("localUser");

    const [getByIdData, setGetByIdData]: any = useState({});
    const [activeTab, setActiveTab] = useState("manual"); // "manual" or "bulk"
    const [bulkFile, setBulkFile] = useState<File | null>(null);

    const [file, setFile] = useState<any>(null);
    const [fileName, setFileName] = useState<string>("");

    const fileHandler = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const fileName = e.target.files[0].name;
            setFileName(fileName);
            const extension = fileName.lastIndexOf(".") + 1;
            const extFile = fileName.substr(extension, fileName.length).toLowerCase();
            setFile(file);
        }
    };

    // ── Lookup state ─────────────────────────────────────
    const [allEntities, setAllEntities] = useState<any[]>([]);
    const [allAssets, setAllAssets] = useState<any[]>([]);
    const [allMethods, setAllMethods] = useState<any[]>([]);
    const [allProjects, setAllProjects] = useState<any[]>([]);
    const [allSpecies, setAllSpecies] = useState<any[]>([]);

    // ── Mutations ────────────────────────────────────────
    const [saveSpecies, saveSpeciesRes] = useSaveSpeciesRegistryMutation();
    const [updateSpecies, updateSpeciesRes] = useUpdateSpeciesRegistryMutation();
    const [getSpeciesById, speciesByIdRes] = useGetSpeciesRegistryByIdMutation();
    const [bulkUploadSpecies, bulkUploadSpeciesRes] = useBulkUploadSpeciesRegistryMutation();

    const [saveMethod, saveMethodRes] = useSaveMethodLibraryMutation();
    const [updateMethod, updateMethodRes] = useUpdateMethodLibraryMutation();
    const [getMethodById, methodByIdRes] = useGetMethodLibraryByIdMutation();
    const [bulkUploadMethod, bulkUploadMethodRes] = useBulkUploadMethodLibraryMutation();

    const [saveRisk, saveRiskRes] = useSaveRiskMaterialityLogMutation();
    const [updateRisk, updateRiskRes] = useUpdateRiskMaterialityLogMutation();
    const [getRiskById, riskByIdRes] = useGetRiskMaterialityLogByIdMutation();
    const [bulkUploadRisk, bulkUploadRiskRes] = useBulkUploadRiskMaterialityLogMutation();

    const [saveEmission, saveEmissionRes] = useSaveEmissionsLedgerMutation();
    const [updateEmission, updateEmissionRes] = useUpdateEmissionsLedgerMutation();
    const [getEmissionById, emissionByIdRes] = useGetEmissionsLedgerByIdMutation();
    const [bulkUploadEmission, bulkUploadEmissionRes] = useBulkUploadEmissionsLedgerMutation();

    const [saveSnapshot, saveSnapshotRes] = useSaveAuditDisclosureSnapshotMutation();
    const [updateSnapshot, updateSnapshotRes] = useUpdateAuditDisclosureSnapshotMutation();
    const [getSnapshotById, snapshotByIdRes] = useGetAuditDisclosureSnapshotByIdMutation();
    const [bulkUploadSnapshot, bulkUploadSnapshotRes] = useBulkUploadAuditDisclosureSnapshotMutation();

    const [saveProject, saveProjectRes] = useSaveCarbonProjectMutation();
    const [updateProject, updateProjectRes] = useUpdateCarbonProjectMutation();
    const [getProjectById, projectByIdRes] = useGetCarbonProjectByIdMutation();
    const [bulkUploadProject, bulkUploadProjectRes] = useBulkUploadCarbonProjectMutation();

    const [saveEmissionFactor, saveEmissionFactorRes] = useSaveEmissionFactorMutation();
    const [updateEmissionFactor, updateEmissionFactorRes] = useUpdateEmissionFactorMutation();
    const [getEmissionFactorById, emissionFactorByIdRes] = useGetEmissionFactorByIdMutation();
    const [bulkUploadEmissionFactor, bulkUploadEmissionFactorRes] = useBulkUploadEmissionFactorMutation();

    const [findAllEntity, findAllEntityRes] = useFindAllEntityMasterMutation();
    const [findAllAssets, findAllAssetsRes] = useFindAllAssetsMutation();
    const [findAllMethods, findAllMethodsRes] = useFindAllMethodLibraryMutation();
    const [findAllProject, findAllProjectRes] = useFindAllCarbonProjectMutation();
    const [findAllSpecies, findAllSpeciesRes] = useFindAllSpeciesRegistryMutation();

    // ── Load lookups ─────────────────────────────────────
    useEffect(() => {
        const token = localUserObj?.token;
        findAllEntity({ token });
        findAllAssets({ token });
        findAllMethods({ token });
        // findAllProject({ token });
        findAllProject({ token: token });
        findAllSpecies({ token });
    }, []);

    useEffect(() => { if (findAllEntityRes.isSuccess) setAllEntities(findAllEntityRes.data?.data || findAllEntityRes.data || []); }, [findAllEntityRes.isSuccess]);
    useEffect(() => { if (findAllAssetsRes.isSuccess) setAllAssets(findAllAssetsRes.data?.data || findAllAssetsRes.data || []); }, [findAllAssetsRes.isSuccess]);
    useEffect(() => { if (findAllMethodsRes.isSuccess) setAllMethods(findAllMethodsRes.data?.data || findAllMethodsRes.data || []); }, [findAllMethodsRes.isSuccess]);
    // useEffect(() => { if (findAllProjectRes.isSuccess) setAllProjects(findAllProjectRes.data?.data || findAllProjectRes.data || []); }, [findAllProjectRes.isSuccess]);
    useEffect(() => {
        if (findAllProjectRes.isSuccess) {
            console.log("Project API Response =>", findAllProjectRes.data);

            setAllProjects(
                findAllProjectRes.data?.data ||
                findAllProjectRes.data ||
                []
            );
        }
    }, [findAllProjectRes.isSuccess]);
    useEffect(() => { if (findAllSpeciesRes.isSuccess) setAllSpecies(findAllSpeciesRes.data?.data || findAllSpeciesRes.data || []); }, [findAllSpeciesRes.isSuccess]);

    // ── Get By Id ────────────────────────────────────────
    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION && props.data?.id) {
            const token = localUserObj?.token;
            const id = props.data.id;
            if (props.reportName === REPORT_NAME.SPECIES_REGISTRY) getSpeciesById({ token, id });
            else if (props.reportName === REPORT_NAME.METHOD_LIBRARY) getMethodById({ token, id });
            else if (props.reportName === REPORT_NAME.RISK_MATERIALITY_LOG) getRiskById({ token, id });
            else if (props.reportName === REPORT_NAME.EMISSIONS_LEDGER) getEmissionById({ token, id });
            else if (props.reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) getSnapshotById({ token, id });
            else if (props.reportName === REPORT_NAME.CARBON_PROJECT_MASTER) getProjectById({ token, id });
            else if (props.reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) getEmissionFactorById({ token, id });
        }
    }, [props.reportName, props.data?.id]);

    useEffect(() => { if (speciesByIdRes.isSuccess) setGetByIdData(speciesByIdRes.data || {}); }, [speciesByIdRes.isSuccess]);
    useEffect(() => { if (methodByIdRes.isSuccess) setGetByIdData(methodByIdRes.data || {}); }, [methodByIdRes.isSuccess]);
    useEffect(() => { if (riskByIdRes.isSuccess) setGetByIdData(riskByIdRes.data || {}); }, [riskByIdRes.isSuccess]);
    useEffect(() => { if (emissionByIdRes.isSuccess) setGetByIdData(emissionByIdRes.data || {}); }, [emissionByIdRes.isSuccess]);
    useEffect(() => { if (snapshotByIdRes.isSuccess) setGetByIdData(snapshotByIdRes.data || {}); }, [snapshotByIdRes.isSuccess]);
    useEffect(() => { if (projectByIdRes.isSuccess) setGetByIdData(projectByIdRes.data || {}); }, [projectByIdRes.isSuccess]);
    useEffect(() => { if (emissionFactorByIdRes.isSuccess) setGetByIdData(emissionFactorByIdRes.data?.data || emissionFactorByIdRes.data || {}); }, [emissionFactorByIdRes.isSuccess]);

    // ── Save/Update effects ──────────────────────────────
    const handleResult = (res: any, name: string) => {
        if (res.isSuccess) { alertMessage(`${name} saved successfully`, "success"); props.setCall("Y"); handleClose(); }
        else if (res.isError) alertMessage(`Error processing ${name}`, "error");
    };

    useEffect(() => handleResult(saveSpeciesRes, "Species"), [saveSpeciesRes.isSuccess, saveSpeciesRes.isError]);
    useEffect(() => handleResult(updateSpeciesRes, "Species"), [updateSpeciesRes.isSuccess, updateSpeciesRes.isError]);
    useEffect(() => handleResult(saveMethodRes, "Method"), [saveMethodRes.isSuccess, saveMethodRes.isError]);
    useEffect(() => handleResult(updateMethodRes, "Method"), [updateMethodRes.isSuccess, updateMethodRes.isError]);
    useEffect(() => handleResult(saveRiskRes, "Risk"), [saveRiskRes.isSuccess, saveRiskRes.isError]);
    useEffect(() => handleResult(updateRiskRes, "Risk"), [updateRiskRes.isSuccess, updateRiskRes.isError]);
    useEffect(() => handleResult(saveEmissionRes, "Emission"), [saveEmissionRes.isSuccess, saveEmissionRes.isError]);
    useEffect(() => handleResult(updateEmissionRes, "Emission"), [updateEmissionRes.isSuccess, updateEmissionRes.isError]);
    useEffect(() => handleResult(saveSnapshotRes, "Snapshot"), [saveSnapshotRes.isSuccess, saveSnapshotRes.isError]);
    useEffect(() => handleResult(updateSnapshotRes, "Snapshot"), [updateSnapshotRes.isSuccess, updateSnapshotRes.isError]);
    useEffect(() => handleResult(saveProjectRes, "Project"), [saveProjectRes.isSuccess, saveProjectRes.isError]);
    useEffect(() => handleResult(updateProjectRes, "Project"), [updateProjectRes.isSuccess, updateProjectRes.isError]);

    useEffect(() => handleResult(bulkUploadSpeciesRes, "Species Bulk"), [bulkUploadSpeciesRes.isSuccess, bulkUploadSpeciesRes.isError]);
    useEffect(() => handleResult(bulkUploadMethodRes, "Method Bulk"), [bulkUploadMethodRes.isSuccess, bulkUploadMethodRes.isError]);
    useEffect(() => handleResult(bulkUploadRiskRes, "Risk Bulk"), [bulkUploadRiskRes.isSuccess, bulkUploadRiskRes.isError]);
    useEffect(() => handleResult(bulkUploadEmissionRes, "Emission Bulk"), [bulkUploadEmissionRes.isSuccess, bulkUploadEmissionRes.isError]);
    useEffect(() => handleResult(bulkUploadSnapshotRes, "Snapshot Bulk"), [bulkUploadSnapshotRes.isSuccess, bulkUploadSnapshotRes.isError]);
    useEffect(() => handleResult(bulkUploadProjectRes, "Project Bulk"), [bulkUploadProjectRes.isSuccess, bulkUploadProjectRes.isError]);

    useEffect(() => handleResult(saveEmissionFactorRes, "Emission Factor"), [saveEmissionFactorRes.isSuccess, saveEmissionFactorRes.isError]);
    useEffect(() => handleResult(updateEmissionFactorRes, "Emission Factor"), [updateEmissionFactorRes.isSuccess, updateEmissionFactorRes.isError]);
    useEffect(() => handleResult(bulkUploadEmissionFactorRes, "Emission Factor Bulk"), [bulkUploadEmissionFactorRes.isSuccess, bulkUploadEmissionFactorRes.isError]);

    const handleClose = () => { props.setShow(false); setActiveTab("manual"); setBulkFile(null); setFile(null); setFileName(""); };

    const handleAutoGenerate = async (values: any, setFieldValue: any) => {
        const projectId = values.projectId;
        const entityId = values.entityId;
        const assetId = values.assetId;
        const dateFilter = values.dateFilter;
        const reportPeriodFromDate = values.reportPeriodFromDate;
        const reportPeriodToDate = values.reportPeriodToDate;
        const token = localUserObj?.token;

        if (!entityId) {
            alertMessage("Please select Entity first!", "error");
            return;
        }
        if (!projectId) {
            alertMessage("Please select Project first!", "error");
            return;
        }
        if (!assetId) {
            alertMessage("Please select Asset first!", "error");
            return;
        }
        if (!dateFilter) {
            alertMessage("Please select Date Filter first!", "error");
            return;
        }
        if (!reportPeriodFromDate) {
            alertMessage("Please select Report Period From Date first!", "error");
            return;
        }
        if (!reportPeriodToDate) {
            alertMessage("Please select Report Period To Date first!", "error");
            return;
        }

        try {
            const base = userManagementBaseUrl || "http://localhost:5034/user-management";
            const baseUrl = base.endsWith('/') ? base.slice(0, -1) : base;
            const queryParams = new URLSearchParams({
                projectId: String(projectId),
                entityId: String(entityId),
                assetId: String(assetId),
                dateFilter: String(dateFilter),
                reportPeriodFromDate: String(reportPeriodFromDate),
                reportPeriodToDate: String(reportPeriodToDate)
            }).toString();
            const response = await fetch(`${baseUrl}/auditDisclosureSnapshot/generateData?${queryParams}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.ok) {
                const result = await response.json();
                const dataToSave = result.data || result;
                setFieldValue("aggregatedData", JSON.stringify(dataToSave, null, 2));
                alertMessage("Data generated successfully!", "success");
            } else {
                alertMessage("Failed to generate data", "error");
            }
        } catch (error) {
            console.error("Error generating data", error);
            alertMessage("Error generating data", "error");
        }
    };

    const handleSubmit = (values: any) => {
        const token = localUserObj?.token;
        const isAdd = props.actionType === ACTION_TYPE.ADD_ACTION;
        let payload: any = { ...(isAdd ? {} : { id: props.data?.id }), ...values, status: isAdd ? true : props.data?.status };

        if (isAdd) {
            delete payload.id;
        } else if (!payload.id && props.data?.id) {
            payload.id = props.data.id;
        }

        if (props.reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) {
            delete payload.assetId;
            delete payload.dateFilter;
            delete payload.reportPeriodFromDate;
            delete payload.reportPeriodToDate;
        }

        if (props.reportName === REPORT_NAME.CARBON_PROJECT_MASTER) {
            payload.isActive = isAdd ? true : props.data?.isActive ?? true;
            delete payload.status;
        }

        if (props.reportName === REPORT_NAME.EMISSIONS_LEDGER && file) {
            const formData = new FormData();
            formData.append("file", file);
            Object.keys(payload).forEach((key) => {
                if (payload[key] !== "" && payload[key] !== null && payload[key] !== undefined) {
                    formData.append(key, payload[key]);
                }
            });
            payload = formData;
        } else {
            Object.keys(payload).forEach((key) => {
                if (payload[key] === "") {
                    payload[key] = null;
                }
            });
        }

        if (props.reportName === REPORT_NAME.SPECIES_REGISTRY) isAdd ? saveSpecies({ token, payload }) : updateSpecies({ token, payload });
        else if (props.reportName === REPORT_NAME.METHOD_LIBRARY) isAdd ? saveMethod({ token, payload }) : updateMethod({ token, payload });
        else if (props.reportName === REPORT_NAME.RISK_MATERIALITY_LOG) isAdd ? saveRisk({ token, payload }) : updateRisk({ token, payload });
        else if (props.reportName === REPORT_NAME.EMISSIONS_LEDGER) isAdd ? saveEmission({ token, payload }) : updateEmission({ token, payload, id: props.data?.id });
        else if (props.reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) isAdd ? saveSnapshot({ token, payload }) : updateSnapshot({ token, payload });
        else if (props.reportName === REPORT_NAME.CARBON_PROJECT_MASTER) isAdd ? saveProject(payload) : updateProject({ id: payload.id, data: payload });
        else if (props.reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) isAdd ? saveEmissionFactor({ token, payload }) : updateEmissionFactor({ token, payload });
    }

    const handleBulkUpload = () => {
        if (!bulkFile) { alertMessage("Please select an XLSX file", "error"); return; }
        const token = localUserObj?.token;
        const formData = new FormData();
        formData.append("file", bulkFile);

        if (props.reportName === REPORT_NAME.SPECIES_REGISTRY) bulkUploadSpecies({ token, payload: formData });
        else if (props.reportName === REPORT_NAME.METHOD_LIBRARY) bulkUploadMethod({ token, payload: formData });
        else if (props.reportName === REPORT_NAME.RISK_MATERIALITY_LOG) bulkUploadRisk({ token, payload: formData });
        else if (props.reportName === REPORT_NAME.EMISSIONS_LEDGER) bulkUploadEmission({ token, payload: formData });
        else if (props.reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) bulkUploadSnapshot({ token, payload: formData });
        else if (props.reportName === REPORT_NAME.CARBON_PROJECT_MASTER) bulkUploadProject(formData);
        else if (props.reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) bulkUploadEmissionFactor({ token, payload: formData });
    };

    const getInitialValues = () => {
        const d = props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData : {};
        if (props.reportName === REPORT_NAME.SPECIES_REGISTRY) {
            return { commonName: d.commonName || "", carbonSequestrationRate: d.carbonSequestrationRate || "", nativeStatus: d.nativeStatus ?? true, regulatedFactor: d.regulatedFactor || "" };
        } else if (props.reportName === REPORT_NAME.METHOD_LIBRARY) {
            return { brsrMetricCode: d.brsrMetricCode || "", calculationLogic: d.calculationLogic || "", lastVerifiedBy: d.lastVerifiedBy || "", isActive: d.isActive ?? true };
        } else if (props.reportName === REPORT_NAME.RISK_MATERIALITY_LOG) {
            return { entityId: d.entityId || d.entity?.id || "", assetId: d.assetId || d.asset?.id || "", brsrPrinciple: d.brsrPrinciple || "", severity: d.severity || "", riskStatus: d.riskStatus || "Identified", riskAssessment: d.riskAssessment || "", contingencyPlan: d.contingencyPlan || "", correctiveAction: d.correctiveAction || "", preventiveAction: d.preventiveAction || "", remarks: d.remarks || "" };
        } else if (props.reportName === REPORT_NAME.EMISSIONS_LEDGER) {
            return { entityId: d.entityId || d.entity?.id || "", assetId: d.assetId || d.asset?.id || "", scopeType: d.scopeType || "", quantity: d.quantity || "", emissionFactorId: d.emissionFactorId || d.emissionFactor?.id || "", entryTimestamp: d.entryTimestamp ? String(d.entryTimestamp).slice(0, 16) : "", satelliteReadingConsumption: d.satelliteReadingConsumption || "", auditTestConsumption: d.auditTestConsumption || "", satelliteImageEvidence: d.satelliteImageEvidence || "", auditorEvidence: d.auditorEvidence || "" };
        } else if (props.reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) {
            let fromDate = "";
            let toDate = "";
            let dateFilter = "Custom";
            try {
                if (d.aggregatedData) {
                    const parsedData = JSON.parse(d.aggregatedData);
                    if (parsedData.company_info && parsedData.company_info.reporting_period) {
                        const parts = parsedData.company_info.reporting_period.split(" to ");
                        if (parts.length === 2) {
                            fromDate = parts[0];
                            toDate = parts[1];
                        }
                    }
                }
            } catch(e) {}
            return { 
                id: d.id || "", 
                entityId: d.entityId || d.entity?.id || "", 
                projectId: d.projectId || d.project?.id || "", 
                assetId: d.project?.asset?.id || "", 
                dateFilter: dateFilter, 
                reportPeriodFromDate: fromDate, 
                reportPeriodToDate: toDate, 
                reportPeriod: d.reportPeriod ? String(d.reportPeriod).slice(0, 10) : "", 
                aggregatedData: d.aggregatedData || "", 
                auditorSignHash: d.auditorSignHash || "", 
                snapshotStatus: d.snapshotStatus || "Draft",
                remarks: d.remarks || ""
            };
        } else if (props.reportName === REPORT_NAME.CARBON_PROJECT_MASTER) {
            return { projectName: d.projectName || "", entityId: d.entityId || d.entity?.id || "", assetId: d.assetId || d.asset?.id || "", speciesId: d.speciesId || d.species?.id || "", startDate: d.startDate || "", projectStatus: d.projectStatus || "ACTIVE" };
        } else if (props.reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) {
            return { factorName: d.factorName || "", factorValue: d.factorValue || "", unit: d.unit || "", authority: d.authority || "", validityStart: d.validityStart ? String(d.validityStart).slice(0, 10) : "", validityEnd: d.validityEnd ? String(d.validityEnd).slice(0, 10) : "", factorVersion: d.factorVersion || "", status: d.status ?? true };
        }
        return {};
    };

    const renderFields = (values: any, setFieldValue: any) => {
        const handleChange = (e: any) => setFieldValue(e.target.name, e.target.value);

        if (props.reportName === REPORT_NAME.SPECIES_REGISTRY) {
            return (
                <>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Common Name</label>
                        <input type="text" className="form-control" name="commonName" value={values.commonName} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Sequestration Rate</label>
                        <input type="number" step="any" className="form-control" name="carbonSequestrationRate" value={values.carbonSequestrationRate} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Native Status</label>
                        <select className="form-select" name="nativeStatus" value={values.nativeStatus} onChange={handleChange}>
                            <option value="true">Native</option>
                            <option value="false">Non-native</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Regulated Factor</label>
                        <input type="number" step="any" className="form-control" name="regulatedFactor" value={values.regulatedFactor} onChange={handleChange} />
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.METHOD_LIBRARY) {
            return (
                <>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">BSRL Metric Code</label>
                        <input type="text" className="form-control" name="brsrMetricCode" value={values.brsrMetricCode} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Verified By</label>
                        <input type="text" className="form-control" name="lastVerifiedBy" value={values.lastVerifiedBy} onChange={handleChange} />
                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Calculation Logic (JSON)</label>
                        <textarea className="form-control" name="calculationLogic" value={values.calculationLogic} onChange={handleChange} rows={3} placeholder='{"factor": 2.68, "unit": "kg/L"}' />
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.RISK_MATERIALITY_LOG) {
            return (
                <>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Entity</label>
                        <select className="form-select" name="entityId" value={values.entityId} onChange={handleChange}>
                            <option value="">-- Select Entity --</option>
                            {allEntities.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Asset</label>
                        <select className="form-select" name="assetId" value={values.assetId} onChange={handleChange}>
                            <option value="">-- Select Asset --</option>
                            {allAssets.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Project</label>
                        <select className="form-select" name="projectId" value={values.projectId} onChange={handleChange}>
                            <option value="">-- Select Project --</option>
                            {allProjects.map(p => <option key={p.id} value={p.id}>{p.projectName}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">BSRL Principle</label>
                        <input type="text" className="form-control" name="brsrPrinciple" value={values.brsrPrinciple} onChange={handleChange} placeholder="e.g. Principle 6" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Severity</label>
                        <select className="form-select" name="severity" value={values.severity} onChange={handleChange}>
                            <option value="">-- Select --</option>
                            <option value="Low">Low</option>
                            <option value="Medium">Medium</option>
                            <option value="High">High</option>
                            <option value="Critical">Critical</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Risk Status</label>
                        <select className="form-select" name="riskStatus" value={values.riskStatus} onChange={handleChange}>
                            <option value="Freeze">Freeze</option>
                            <option value="Under-Investigation">Under-Investigation</option>
                            <option value="Closed">Closed</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Risk Assessment</label>
                        <input type="text" className="form-control" name="riskAssessment" value={values.riskAssessment} onChange={handleChange} placeholder="Enter Risk Assessment" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Contingency Plan</label>
                        <input type="text" className="form-control" name="contingencyPlan" value={values.contingencyPlan} onChange={handleChange} placeholder="Enter Contingency Plan" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Corrective Action</label>
                        <input type="text" className="form-control" name="correctiveAction" value={values.correctiveAction} onChange={handleChange} placeholder="Enter Corrective Action" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Preventive Action</label>
                        <input type="text" className="form-control" name="preventiveAction" value={values.preventiveAction} onChange={handleChange} placeholder="Enter Preventive Action" />
                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Remarks</label>
                        <textarea className="form-control" name="remarks" value={values.remarks} onChange={handleChange} rows={3} placeholder="Enter Remarks" />
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.EMISSIONS_LEDGER) {
            return (
                <>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Entity</label>
                        <select className="form-select" name="entityId" value={values.entityId} onChange={handleChange}>
                            <option value="">-- Select Entity --</option>
                            {allEntities.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Asset</label>
                        <select className="form-select" name="assetId" value={values.assetId} onChange={handleChange}>
                            <option value="">-- Select Asset --</option>
                            {allAssets.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Project</label>
                        <select className="form-select" name="projectId" value={values.projectId} onChange={handleChange}>
                            <option value="">-- Select Project --</option>
                            {allProjects.map(p => <option key={p.id} value={p.id}>{p.projectName}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Scope</label>
                        <select className="form-select" name="scopeType" value={values.scopeType} onChange={handleChange}>
                            <option value="">-- Select --</option>
                            <option value="Scope 1">Scope 1 (Direct)</option>
                            <option value="Scope 2">Scope 2 (Energy)</option>
                            <option value="Scope 3">Scope 3 (Value Chain)</option>
                            <option value="Scope 4">Scope 4 (Others)</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Quantity</label>
                        <input type="number" step="any" className="form-control" name="quantity" value={values.quantity} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Emission Factor (Method)</label>
                        <select className="form-select" name="emissionFactorId" value={values.emissionFactorId} onChange={handleChange}>
                            <option value="">-- Select Method --</option>
                            {allMethods.map(m => <option key={m.id} value={m.id}>{m.brsrMetricCode}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Timestamp</label>
                        <input type="datetime-local" className="form-control" name="entryTimestamp" value={values.entryTimestamp} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Satellite Reading Consumption</label>
                        <input type="number" step="any" className="form-control" name="satelliteReadingConsumption" value={values.satelliteReadingConsumption} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Audit Test Consumption</label>
                        <input type="number" step="any" className="form-control" name="auditTestConsumption" value={values.auditTestConsumption} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Satellite Image Evidence (URL)</label>
                        <input type="text" className="form-control" name="satelliteImageEvidence" value={values.satelliteImageEvidence} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Auditor Evidence (URL)</label>
                        <input type="text" className="form-control" name="auditorEvidence" value={values.auditorEvidence} onChange={handleChange} />

                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Remarks</label>
                        <textarea className="form-control" name="remarks" value={values.remarks} onChange={handleChange} rows={3} placeholder="Enter Remarks" />
                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold d-block">Upload File</label>
                        <div className="mt-2">
                            <label className="btn border-0 text-white m-0" style={{ background: "var(--accent, #2563eb)", cursor: "pointer" }}>
                                Upload file
                                <input
                                    type="file"
                                    onChange={fileHandler}
                                    style={{ display: "none" }}
                                />
                            </label>
                        </div>
                        {fileName && (
                            <div className="mt-2">
                                Selected File: {fileName}
                            </div>
                        )}
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.AUDIT_DISCLOSURE_SNAPSHOT) {
            return (
                <>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Entity</label>
                        <select className="form-select" name="entityId" value={values.entityId} onChange={handleChange}>
                            <option value="">-- Select Entity --</option>
                            {allEntities.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Project</label>
                        <select className="form-select" name="projectId" value={values.projectId} onChange={handleChange}>
                            <option value="">-- Select Project --</option>
                            {allProjects.map(p => <option key={p.id} value={p.id}>{p.projectName}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Asset</label>
                        <select className="form-select" name="assetId" value={values.assetId || ""} onChange={handleChange}>
                            <option value="">-- Select Asset --</option>
                            {allAssets.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Date Filter</label>
                        <select className="form-select" name="dateFilter" value={values.dateFilter || ""} onChange={handleChange}>
                            <option value="">-- Select Date Filter --</option>
                            <option value="Daily">Daily</option>
                            <option value="Weekly">Weekly</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Yearly">Yearly</option>
                            <option value="Custom">Custom</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Report Period From Date</label>
                        <input type="date" className="form-control" name="reportPeriodFromDate" value={values.reportPeriodFromDate || ""} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Report Period To Date</label>
                        <input type="date" className="form-control" name="reportPeriodToDate" value={values.reportPeriodToDate || ""} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Report Period</label>
                        <input type="date" className="form-control" name="reportPeriod" value={values.reportPeriod} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Status</label>
                        <select className="form-select" name="snapshotStatus" value={values.snapshotStatus} onChange={handleChange}>
                            <option value="Draft">Draft</option>
                            <option value="Frozen">Frozen</option>
                            <option value="Verified">Verified</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Auditor Signature Hash</label>
                        <input type="text" className="form-control" name="auditorSignHash" value={values.auditorSignHash} onChange={handleChange} readOnly={props.actionType === ACTION_TYPE.UPDATE_ACTION} />
                    </div>
                    <div className="col-md-12 mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="form-label fw-semibold mb-0">Aggregated Data (JSON Summary)</label>
                            <button type="button" className="btn btn-sm text-white" style={{ background: "var(--accent, #2563eb)" }} onClick={() => handleAutoGenerate(values, setFieldValue)}>
                                Auto-Generate Data
                            </button>
                        </div>
                        <textarea className="form-control" name="aggregatedData" value={values.aggregatedData} onChange={handleChange} rows={5} />
                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Remarks</label>
                        <textarea className="form-control" name="remarks" value={values.remarks} onChange={handleChange} rows={3} placeholder="Enter Remarks" />
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.CARBON_PROJECT_MASTER) {
            return (
                <>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Project Name</label>
                        <input type="text" className="form-control" name="projectName" value={values.projectName} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Lead Promoter (Entity)</label>
                        <select className="form-select" name="entityId" value={values.entityId} onChange={handleChange}>
                            <option value="">-- Select Entity --</option>
                            {allEntities.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Primary Asset</label>
                        <select className="form-select" name="assetId" value={values.assetId} onChange={handleChange}>
                            <option value="">-- Select Asset --</option>
                            {allAssets.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Primary Species</label>
                        <select className="form-select" name="speciesId" value={values.speciesId} onChange={handleChange}>
                            <option value="">-- Select Species --</option>
                            {allSpecies.map(s => <option key={s.id} value={s.id}>{s.commonName}</option>)}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Start Date</label>
                        <input type="date" className="form-control" name="startDate" value={values.startDate} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Status</label>
                        <select className="form-select" name="projectStatus" value={values.projectStatus} onChange={handleChange}>
                            <option value="ACTIVE">Active</option>
                            <option value="COMPLETED">Completed</option>
                            <option value="PAUSED">Paused</option>
                        </select>
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.EMISSION_FACTOR_MASTER) {
            return (
                <>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Factor Name</label>
                        <input type="text" className="form-control" name="factorName" value={values.factorName} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Factor Value</label>
                        <input type="number" step="any" className="form-control" name="factorValue" value={values.factorValue} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Unit</label>
                        <input type="text" className="form-control" name="unit" value={values.unit} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Authority</label>
                        <input type="text" className="form-control" name="authority" value={values.authority} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Validity Start</label>
                        <input type="date" className="form-control" name="validityStart" value={values.validityStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Validity End</label>
                        <input type="date" className="form-control" name="validityEnd" value={values.validityEnd} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Version</label>
                        <input type="text" className="form-control" name="factorVersion" value={values.factorVersion} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Status</label>
                        <select className="form-select" name="status" value={values.status} onChange={handleChange}>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>
                    </div>
                </>
            );
        }
        return null;
    };

    const isMutationLoading =
        saveSpeciesRes.isLoading || updateSpeciesRes.isLoading || bulkUploadSpeciesRes.isLoading ||
        saveMethodRes.isLoading || updateMethodRes.isLoading || bulkUploadMethodRes.isLoading ||
        saveRiskRes.isLoading || updateRiskRes.isLoading || bulkUploadRiskRes.isLoading ||
        saveEmissionRes.isLoading || updateEmissionRes.isLoading || bulkUploadEmissionRes.isLoading ||
        saveSnapshotRes.isLoading || updateSnapshotRes.isLoading || bulkUploadSnapshotRes.isLoading ||
        saveProjectRes.isLoading || updateProjectRes.isLoading || bulkUploadProjectRes.isLoading ||
        saveEmissionFactorRes.isLoading || updateEmissionFactorRes.isLoading || bulkUploadEmissionFactorRes.isLoading;

    return (
        <Modal show={props.show} onHide={handleClose} size="lg" centered scrollable>
            <Modal.Header closeButton className="bg-cm-light-primary1 border-0">
                <Modal.Title className="text-accent fw-bold">
                    {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"} {props.reportName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isMutationLoading && <Loading />}

                {props.actionType === ACTION_TYPE.ADD_ACTION && (
                    <div className="d-flex mb-3 border-bottom pb-2">
                        <button type="button" className={`btn btn-sm me-2 ${activeTab === "manual" ? "bg-accent text-white" : "btn-outline-secondary"}`} onClick={() => setActiveTab("manual")}>
                            Manual Entry
                        </button>
                        <button type="button" className={`btn btn-sm ${activeTab === "bulk" ? "bg-accent text-white" : "btn-outline-secondary"}`} onClick={() => setActiveTab("bulk")}>
                            Bulk Upload
                        </button>
                    </div>
                )}

                {activeTab === "manual" ? (
                    <Formik initialValues={getInitialValues()} enableReinitialize onSubmit={handleSubmit}>
                        {({ values, setFieldValue, handleSubmit }) => (
                            <Form onSubmit={handleSubmit}>
                                <div className="row">
                                    {renderFields(values, setFieldValue)}
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                    <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>Cancel</button>
                                    <button type="submit" className="btn border-0 text-white" style={{ background: "var(--accent, #2563eb)" }}>
                                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Save" : "Update"}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                ) : (
                    <div className="row">
                        <div className="col-12 mb-3">
                            <label className="form-label fw-semibold">Select XLSX File for {props.reportName}</label>
                            <input type="file" className="form-control" accept=".xlsx" onChange={(e) => setBulkFile(e.target.files ? e.target.files[0] : null)} />
                        </div>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>Cancel</button>
                            <button type="button" className="btn border-0 text-white" style={{ background: "var(--accent, #2563eb)" }} onClick={handleBulkUpload}>
                                Upload
                            </button>
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default BSRLComplianceData;
